import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import { DateTime } from "luxon";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import RoleRequire from "../../../helpers/auth/RoleRequire";
import { useRefreshShifts } from "../../../hooks/useRefreshStateHooks/useRefreshShifts";
import { useAppStore } from "../../../stores/RootStore";
import { FShift } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Separator } from "../../../ui/Separator";
import { MenuDataTable } from "../../../ui/DataTable/MenuDataTable";
import { Header } from "../../../components/Header";

type Props = {};

export const Shifts = (props: Props) => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const [search, setSearch] = React.useState("");
  const currentSite = useAppStore().currentSite
  const shifts = useAppStore((state) => state.shifts.filter((shift) => shift.id != "full"));
  const navigate = useNavigate();

  // Получение данных и обновление их в сторе.
  const updateItems = useRefreshShifts();
  useEffect(() => {
    updateItems();
  }, []);

  let nodes = shifts?.map((shift) => {
    return {
      id: shift.id,
      name: shift.name,
      start_at: shift.start_at,
      end_at: shift.end_at,
      working_shift_breaks: shift.working_shift_breaks
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())),
  };

  

  const columns: ColumnDef<FShift>[] = [
    {
      header: t("shift_name"),
      size: 1000,
      cell: ({ row }) => row.original.name,
    },
    {
      header: t("shift_start_time"),
      size: 150,
      cell: ({ row }) => row.original.start_at.toLocaleString(DateTime.TIME_24_SIMPLE),
    },
    {
      header: t("shift_end_time"),
      size: 150,
      cell: ({ row }) => row.original.end_at.toLocaleString(DateTime.TIME_24_SIMPLE),
    }
  ];

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}>
            <span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span> 
          </NavLink>
          <span>/</span>
          <NavLink to={"/data/directories"}>
            <span className="font-medium">{t("directories")}</span>
          </NavLink> 
          
          <span>/</span>
          {location.pathname == "/data/shifts/" || location.pathname == "/data/shifts" ? <span>{t("shifts")}</span> : <NavLink to={"/data/shifts"}><span>{t("shifts")}</span></NavLink>}
          {(id || location.pathname == "/data/shifts/new") && <span>/</span>}
          {id && <span>{data.nodes.find(n => n.id == id)?.name}</span>}
          {location.pathname == "/data/shifts/new" && <span>{t('adding_shift')}</span>}
        </div>
      </div>
      <Separator className="flex-none"/>
      {id || location.pathname == "/data/shifts/new" ? <Outlet /> :
        <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
          <Header name={t('shifts')} backName={t("directories")} backLink={"/data/directories"} />
          <div className="flex-none flex flex-row w-full h-10 items-center gap-4 justify-between px-6">
            <Input 
              className="h-8"
              placeholder={t("search")}
              onChange={handleSearch}
              value={search}
              autoComplete="off"
              width="100%" 
            />
            <RoleRequire role="maintainer">
              <Button variant={"default"} size={"md"} onClick={() => navigate("new")}>{t("create_shift")}</Button>
            </RoleRequire>
          </div>
          <MenuDataTable route="/data/shifts" data={data.nodes} columns={columns} onClickRow={navigate} />
        </div>
      }
    </div>
  );
};